<template>
    <PDA_addpda-components>
        <div>
            <b-row>
                <!-- Table -->
                <b-col md="4">
                    <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage" :busy="isBusy" id="my-table">
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>  
                        <template slot="pda_name" slot-scope="row">
                            <div>
                                <!-- <b-form-radio @input="editPDAinfo(row.item)" :aria-describedby="ariaDescribedby" name="some-radios" :value="row.item">&nbsp;{{row.item.pda_name}}</b-form-radio> -->
                                <!-- #0da9ae -->
                                <span style="font-size: 16px; color: #1c9ac7; cursor: pointer;" @click="!isReadOnly && editPDAinfo(row.item)"> <b> &gt; </b> &nbsp;{{row.item.pda_name}}</span>
                            </div>
                        </template>
                    </b-table>
        
                    <!-- paginaton -->
                    <b-col md="12">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table"></b-pagination>
                    </b-col>
                </b-col>
                <b-col md="1">
                    <div id="listloader" v-if="Loader">
                        <div class="listloader"></div>
                    </div>
                </b-col>
                <b-col md="7" class="mt-5" v-if="addPDA">
                    <b-row>
                        <b-col md="7">
                            <b-row>
                                <b-col md="4">
                                    <strong>PDA Name : </strong>
                                </b-col>
                                <b-col md="8">
                                    <b-form-input v-model.trim="customer.pdaname" placeholder="Enter PDA Name" name="PDA Name"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5">
                            <b-row>
                                <b-col md="7">
                                    <strong>Active / InActive : </strong>
                                </b-col>
                                <b-col md="5">
                                    <b-form-checkbox switch class="mr-n2" v-model="customer.status">
                                        <span class="sr-only">Switch for previous text input</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="11">
                            <div class="text-right">
                                <br>
                                <b-button variant="primary" type="submit" @click="addPDAList()" :disabled="isReadOnly">Save</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7" class="mt-5" v-if="editPDA">
                    <b-row>
                        <b-col md="7">
                            <b-row>
                                <b-col md="4">
                                    <strong>PDA ID : </strong>
                                </b-col>
                                <b-col md="8">
                                    <b-form-input v-model.trim="user.pdaname" placeholder="Enter PDA ID" name="PDA ID"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="5">
                            <b-row>
                                <b-col md="7">
                                    <strong>Active / InActive : </strong>
                                </b-col>
                                <b-col md="5">
                                    <b-form-checkbox switch class="mr-n2" @change="checkstatus" :checked="user.status === '1' || user.status === 'Yes'">
                                        <span class="sr-only">Switch for previous text input</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="11">
                            <div class="text-right">
                                <br>
                                <b-button variant="primary" type="submit" @click="editPDAList()" :disabled="isReadOnly">Save</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>  
    </PDA_addpda-components>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    name :'PDA_addpda',

    data() {
        return {
            Loader:false,
        
            // Table
            isBusy:false,
            totalRows:0,
            items:[],
            fields:[
                {key:'pda_name', label:'PDA Name',thClass: 'text-center'},
                // {key:'is_active', label:'Status'},
                // {key:'lastdata', label:'Last Modified By'},
            ],
            currentPage:1,
            perPage:20,
            customer:{},
            addPDA:true,

            editPDA:false,
            user:{},
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
          this.ischeckbodyvalidation();
        this.pdaList()
    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='PDA Configuration' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='PDA Configuration' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        pdaList(){
            this.items=[];
            this.totalRows=0;
            
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={
                status:'add',
                hub_id:userInfo.hub_id,
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addedPDAListing`,Obj)
            .then(result=>{
                this.isBusy=false;
                if (result.body.returnmsg==='Successful') {
                    this.items = result.body.returnvalue;
                    this.totalRows =  this.items.length;
                } else {
                    this.items=[];
                    this.totalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        addPDAList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.Loader = true;
            

            if (this.customer.pdaname==undefined || this.customer.pdaname==null || this.customer.pdaname=="" || this.customer.pdaname=='undefined' || this.customer.pdaname=='null') {
                this.$fire({
                    text: 'Please Enter PDA Name',
                    type: "warning",
                    timer: 30000,
                });
                this.Loader = false;
                return false;
            }

            const Obj = {
                pda_name: `${this.customer.pdaname}`,
                is_active: `${this.customer.status?'1':'0'}`,
                createdby: `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                hub_id:userInfo.hub_id
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addPDAInSystem`,Obj)
            .then(result=>{
                console.log("result",result)
                this.Loader = false;
                if (result.body.returnmsg==='Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                    this.pdaList()
                    this.customer={};
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        editPDAinfo(value){
            this.user = {};
            this.addPDA = false;
            this.editPDA = true;
            this.user.pda_id = value.pda_id;
            this.user.pdaname = value.pda_name;
            this.user.status = value.is_active;
        },

        checkstatus(value){
            if (value===false) {
                this.user.status='0';
            } else {
                this.user.status='1';
            }
        },

        editPDAList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.Loader = true;
            

            if (this.user.pdaname==undefined || this.user.pdaname==null || this.user.pdaname=="" || this.user.pdaname=='undefined' || this.user.pdaname=='null') {
                this.$fire({
                    text: 'Please Enter PDA Name',
                    type: "warning",
                    timer: 30000,
                });
                this.Loader = false;
                return false;
            }
            
            const Obj = {
                pda_id: `${this.user.pda_id}`,
                is_active: `${this.user.status}`,
                lastmodifiedby: `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/activeInactivePDA`,Obj)
            .then(result=>{
                console.log("result",result)
                this.Loader = false;
                if (result.body.returnmsg==='Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                    this.pdaList()
                    this.user={};
                    this.addPDA = true;
                    this.editPDA = false;
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
    },

    computed: {
        rows() {
            return this.items.length
        }
    }
}
</script>